import React from 'react';
import { Box, Stack, Tooltip, alpha, useTheme } from '@mui/material';

import { PERIOD_SLOTS } from './constants';
import { getPeriodSlots } from './utils';

export default function PeriodDots({ periodsFound }) {
  const theme = useTheme();
  const slots = getPeriodSlots(periodsFound);

  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      {PERIOD_SLOTS.map((slot) => (
        <Tooltip key={slot.key} title={`${slot.label}: ${slots[slot.key] ? 'บันทึกแล้ว' : 'ยังไม่บันทึก'}`}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: slots[slot.key] ? theme.palette.success.main : alpha(theme.palette.text.disabled, 0.3),
            }}
          />
        </Tooltip>
      ))}
    </Stack>
  );
}
